import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Col, Input, Select, Button, Form, Upload, Divider, message} from 'antd';
import DocumentMeta from 'react-document-meta';
import {contactsMeta} from '../constants/meta';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhoneSquareAlt, faMailBulk} from '@fortawesome/free-solid-svg-icons';
import {Section, PageHeader} from '../common';
import {UploadOutlined} from '@ant-design/icons';

const Contacts = () => {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const onFinish = (values) => {
    setIsLoading(true);
    const bodyFormData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === "file-712") {
        bodyFormData.append(key, file);
      } else {
        bodyFormData.append(key, values[key]);
      }
    });

    axios.post("https://www.studentite.com/wp/wp-json/contact-form-7/v1/contact-forms/64/feedback", bodyFormData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      setIsLoading(false);
      if (response.data.status === "validation_failed") {
        message.error(response.data.message);
      } else {
        message.success(response.data.message);
      }
    }).catch((err) => {
      setIsLoading(false);
      message.error("Възникна грешка при изпращане на съобщението.");
    });
  }
  return (
    <DocumentMeta {...contactsMeta}>
      <PageHeader title="Контакти" />
      <Section>
        <Col xs={24}>
          <p><FontAwesomeIcon className="secondary-light-color" icon={faPhoneSquareAlt} /> <strong>Телефон:</strong> 0899 104090</p>
          <p><FontAwesomeIcon className="secondary-light-color" icon={faMailBulk} /> <strong>И-мейл:</strong> office@studentite.com</p>
        </Col>
        <br/>
        <Divider orientation="left"><h2>Контактна форма</h2></Divider>
        <Col xs={24}>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item label="Име:" name="your-name">
              <Input type="text"  />
            </Form.Item>
            <Form.Item label="Имейл:" name="your-email">
              <Input type="email"  />
            </Form.Item>
            <Form.Item label="Телефон:" name="tel-679">
              <Input type="tel"  />
            </Form.Item>
            <Form.Item label="Вид" name="type">
              <Select name="type" className="wpcf7-form-control wpcf7-select" style={{width: "100%"}}>
                <Select.Option value="Курсова работа">Курсова работа</Select.Option>
                <Select.Option value="Казус">Казус</Select.Option>
                <Select.Option value="Реферат">Реферат</Select.Option>
                <Select.Option value="Дипломна работа">Дипломна работа</Select.Option>
                <Select.Option value="Магистърса теза">Магистърса теза</Select.Option>
                <Select.Option value="Есе">Есе</Select.Option>
                <Select.Option value="Доклад">Доклад</Select.Option>
                <Select.Option value="Задача">Задача</Select.Option>
                <Select.Option value="Тест">Тест</Select.Option>
                <Select.Option value="Друго">Друго</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label="Изисквания" name="your-message">
              <Input.TextArea name="your-message" cols="40" rows="10" />
            </Form.Item>
            <Form.Item name="file-712">
              <Upload maxCount={1} beforeUpload={(uploadedFile) => {
                setFile(uploadedFile);
                return false;
              }}>
                <Button icon={<UploadOutlined />}>Избери файл</Button>
              </Upload>
            </Form.Item>

            <Button loading={isLoading} type="primary" htmlType="submit">Изпращане</Button>
          </Form>
        </Col>
        <Divider />
        <Col xs={24}>
          <p>Свържете се с нас за съдействие при разработването на вашата <Link to="/masters/" className="no-style">магистърска</Link> или <Link to="/bachelores/" className="no-style">бакалавърска теза</Link>, курсова работа, реферат, персонализирани предложения за вашето дистанционно обучение, <Link to="/students/" className="no-style">решаване на тест</Link> за изпит и други въпроси.</p>
          <p>Ние гарантираме професионализъм и конфиденциалност по време на целия процес.</p>
        </Col>
      </Section>
    </DocumentMeta>
  );
};

export default Contacts;